import { IStatsPercategory } from '@shared/models';

export const PILLAR_SKILLS_SKELETON_DATA: IStatsPercategory[] = [
    {
        categoryId: '1',
        name: 'Personal Development',
        badgeColor: 'TEAL',
        overallChallenges: 4,
        overallEvents: 13,
        takenEvents: 1,
        takenChallenges: 3,
        totalModules: 4,
        overallCompletedModules: 4,
        avgCompletion: 38.095238095238095,
        avgGrade: 91.66666666666666,
    },
    {
        categoryId: '2',
        name: 'Communication',
        badgeColor: 'GREEN',
        overallChallenges: 4,
        overallEvents: 4,
        takenEvents: 1,
        takenChallenges: 3,
        totalModules: 4,
        overallCompletedModules: 3,
        avgCompletion: 58.333333333333336,
        avgGrade: 83.33333333333333,
    },
    {
        categoryId: '3',
        name: 'Active Citizenship',
        badgeColor: 'PINK',
        overallChallenges: 2,
        overallEvents: 1,
        takenEvents: 0,
        takenChallenges: 2,
        totalModules: 4,
        overallCompletedModules: 2,
        avgCompletion: 57.14285714285714,
        avgGrade: 100,
    },
    {
        categoryId: '4',
        name: 'Learning',
        badgeColor: 'ORANGE',
        overallChallenges: 8,
        overallEvents: 1,
        takenEvents: 0,
        takenChallenges: 1,
        totalModules: 7,
        overallCompletedModules: 7,
        avgCompletion: 50,
        avgGrade: 94.44444444444444,
    },
    {
        categoryId: '5',
        name: 'Employability',
        badgeColor: 'PURPLE',
        overallChallenges: 0,
        overallEvents: 1,
        takenEvents: 1,
        takenChallenges: 0,
        totalModules: 4,
        overallCompletedModules: 4,
        avgCompletion: 100,
        avgGrade: 83.33333333333333,
    },
];
